const Title = ({title = ''}) => {
    return ( 
        <div className="ruler ruler--primary mb-2">
            <h1 className="h2 heading-title py-1 m-0">{title}</h1>
        </div>
    )
}

export default Title